import {
  OreButton,
  OreCardContainer,
  OreCardWrapper,
  OreDivider,
  OreHeading,
  OreStack,
  OreText,
} from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { navigationRoutes } from '@/Shared/ui/routers'
import { storesTranslation } from '@/Store/ui/storesTranslation'

interface TpvAccessCardProps {
  largeVersion?: boolean
}

export const TpvAccessCard = ({
  largeVersion = false,
}: TpvAccessCardProps): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <OreCardContainer>
      <OreCardWrapper>
        <OreStack placeContent="stretch" space="small">
          <OreHeading as="h2" size="headline-md">
            {t(storesTranslation.tpvs.accessCard.title)}
          </OreHeading>

          <OreDivider />

          <OreStack
            placeContent="space-between"
            direction={largeVersion ? 'row' : 'column'}
          >
            <OreStack placeContent="start" space="xsmall">
              <OreText>{t(storesTranslation.tpvs.accessCard.description)}</OreText>
            </OreStack>
            <OreStack placeContent="start" space="small">
              <OreButton
                category="secondary"
                onClick={() => navigate(navigationRoutes.storeTPV)}
              >
                {t(storesTranslation.tpvs.accessCard.button.label)}
              </OreButton>
            </OreStack>
          </OreStack>
        </OreStack>
      </OreCardWrapper>
    </OreCardContainer>
  )
}
